import type { ID } from '@recruitee/ngrx';
import { createEntityCollectionStore, pipeState } from '@recruitee/ngrx';

import type {
  RequisitionAssignmentEntity,
  RequisitionAssignmentsUpdatePayload,
} from './assignments.types';

const { actions, selectors, reducer, namespace } =
  createEntityCollectionStore<RequisitionAssignmentEntity>()('RequisitionAssignments', {
    customActions: adapter => ({
      updateOnePessimistic: (state, payload: RequisitionAssignmentsUpdatePayload) =>
        adapter.markAsPending(state),
      removeOnePessimistic: (
        state,
        payload: { data: { requisitionId: ID; assignmentId: number } },
      ) => adapter.markAsPending(state),
      removeOnePessimisticSuccess: (
        state,
        payload: { data: { requisitionId: ID; assignmentId: number } },
      ) => {
        const { requisitionId, assignmentId } = payload.data;

        const entity = {
          id: state.entityMap[requisitionId]!.id,
          assignments: [
            ...state.entityMap[requisitionId]!.assignments.filter(
              assignment => assignment.id !== assignmentId,
            ),
          ],
        };

        return pipeState(state, next => adapter.upsertOne(next, entity));
      },
    }),
  });

export {
  actions as RequisitionAssignmentsActions,
  selectors as RequisitionAssignmentsSelectors,
  reducer as RequisitionAssignmentsReducer,
  namespace as RequisitionAssignmentsNamespace,
};
